(ns rothko.css.inline
  #?@(:cljs [(:require [rothko.css.browser :as browser])
             (:require-macros [rothko.css.inline :refer [declarations->class
                                                         cond-declarations->class]])]))

(defn make-classname
  [symbol]
  (clojure.string/replace (str symbol) #"[^a-zA-Z0-9-_]" "_"))

(defn declaration->class
  [decl]
  (if (list? decl)
    `(let [class# (make-classname #'~(first decl))]
       (rothko.css.browser/set-style! class# ~decl)
       class#)
    `(let [class# (make-classname #'~decl)]
       (rothko.css.browser/set-style! class# ~decl)
       class#)))

#?(:clj
   (defmacro declarations->class
     [& declarations]
     (vec
      (for [decl declarations]
        (declaration->class decl)))))

(defn cond-declarations->class*
  [declaration clauses]
  (let [class (gensym)
        clauses (map (fn [[test decl]]
                       `(if ~test
                          (conj ~class ~(declaration->class decl))
                          ~class))
                     (partition 2 clauses))]
    `(let [~class [~(when declaration
                      (declaration->class declaration))]
           ~@(interleave (repeat class) clauses)]
       (remove nil? ~class))))

#?(:clj
   (defmacro cond-declarations->class
     [declaration & clauses]
     (if (even? (count clauses))
       (cond-declarations->class* declaration clauses)
       (let [clauses (conj clauses declaration)]
         (cond-declarations->class* nil clauses)))))
